<template>
  <div class="delete-dialog">
    <el-dialog
      title=""
      :visible.sync="display"
      center
      width="60%">
      <div style="margin-bottom:20px;font-weight:bold">角色: {{this.selectedRole.roleName}}</div>
      <el-table :data="tableData">
        <el-table-column
          label="序号"
          type="index"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column property="userName" label="姓名" align="center"></el-table-column>
        <el-table-column property="userAccount" label="账号" align="center"></el-table-column>
        <el-table-column  label="角色" align="center">
          {{this.selectedRole.roleName}}
        </el-table-column>
        <!-- <el-table-column property="relShopIdNum" label="关联门店数" align="center"></el-table-column> -->
        <el-table-column property="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column property="userStatus" label="状态" align="center">
           <template slot-scope="scope">
           <span>
             {{scope.row.userStatus===1?'启用':'停用'}}
           </span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="paginations.pageSize" @changePage="onChangeCurrentPage" :count="paginations.count" :page-no="paginations.pageNum"></pagination>
    </el-dialog>
  </div>
</template>

<script>

import pagination from '@/components/pagination'
import { queryUserByRole } from '@/api/userAccount.js'
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    selectedRole: {
      type: Object,
      default: function () {
        return {
          roleId: '',
          roleName: ''
        }
      }
    }
  },
  components: {
    pagination
  },
  data () {
    return {
      tableData: [],
      display: this.show,
      searchForm: {
        roleId: ''
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        count: 0,
        pageSize: 10
      }
    }
  },
  mounted () {
  },
  watch: {
    show: function (nval) {
      this.display = nval // show改变是同步子组件display的值
      this.getList()
    },
    display: function (nval) {
      this.$emit('update:show', nval) // display改变时同步父组件show的值
    }
  },
  methods: {
    /**
     * @description 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      this.paginations.pageNum = page
      this.getList()
    },
    getList () {
      this.searchForm.roleId = this.selectedRole.roleId
      const params = Object.assign(this.searchForm, this.paginations)
      queryUserByRole(params).then(response => {
        if (+response.error_code === 0) {
          this.tableData = response.data.list
          this.paginations.count = response.data.totalCount
        } else {
          this.$message({
            message: response.error_msg,
            type: 'error'
          })
        }
      })
    }
  }

}
</script>

<style lang='scss' scoped>

</style>
